import { api } from '../utils/request'

/**
 * Auth API - Form submissions should skip global loader
 * Using skipLoader: true to prevent full-screen loader on form submit
 */

export const login = async (data) => {
    const resp = await api({
        endpoint: '/user/login',
        method: 'POST',
        data,
        skipLoader: true, // Skip loader for form submission
    })
    return resp
}

export const register = async (data) => {
    const resp = await api({
        endpoint: '/user/register',
        method: 'POST',
        data,
        skipLoader: true, // Skip loader for form submission
    })
    return resp
}